import { Navigate, useLocation } from 'react-router-dom'
import { ReactNode } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { useLocale } from '../../context/LocaleContext'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()
  const { url } = useLocale()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    const price = new URLSearchParams(location.search).get('plan_price_id')
    const target = ['/subscription', '/checkout'].includes(location.pathname)
      ? price && /^[1-9]\d*$/.test(price) ? `/login?plan_price_id=${encodeURIComponent(price)}` : location.pathname === '/checkout' ? '/login?payment=return' : '/login'
      : location.pathname === '/welcome' ? '/login?intent=trial' : '/login'
    return <Navigate to={url(target)} replace />
  }

  return <>{children}</>
}
